import React, { useEffect, useRef } from 'react';
import Navigation from '../components/Navigation';
import FooterCenteredTransparent from '../components/FooterCenteredTransparent';
import CTA from '../components/CTA';
import { DotLottie } from '@lottiefiles/dotlottie-web';
import { motion } from "framer-motion";

export default function Contact() {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (canvasRef.current) {
            new DotLottie({
                autoplay: true,
                loop: true,
                canvas: canvasRef.current,
                src: "https://lottie.host/1870be1f-3e6d-465b-b0a4-778f67f86e22/jyPpTIqTus.json",
            });
        }
    }, []);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="bg-void min-h-screen"
        >
            <Navigation />
            <div className="mx-auto max-w-2xl pt-36 sm:pt-40 lg:pt-44 px-6">
                <div className="text-center">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <p className="text-xs font-outfit font-semibold tracking-[0.2em] uppercase text-accent mb-4">
                            Get in Touch
                        </p>
                        <h1 className="font-syne text-3xl sm:text-4xl font-bold text-text-primary">
                            Send us a message anytime
                        </h1>
                        <p className="mt-6 font-outfit text-base text-text-secondary">
                            For any inquiries, reach out to{' '}
                            <a href="mailto:hello@bigweblabs.com" className="text-accent hover:underline font-medium">
                                hello@bigweblabs.com
                            </a>
                        </p>
                    </motion.div>
                </div>
            </div>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { delay: 0.5 } }}
                className="flex justify-center items-center pb-20"
            >
                <canvas ref={canvasRef} id="maillottie-canvas" style={{ width: '250px', height: '250px' }} />
            </motion.div>
            <CTA />
            <FooterCenteredTransparent />
        </motion.div>
    );
}
